/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DataList, EmptyState, EmptyStateProps, ICON_SWITCH_ACCESS_SHORTCUT_WITH_LIST } from '@squiz/sds';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CDP_STRINGS } from '../../../../Constants/Strings.constants';
import { CUSTOMER_PROFILE_DATA_IDS } from '../../CustomerProfile.constants';

/**
 * The content of the recent events panel in the customer details tab.
 */
export const CustomerRecentEvents = (): JSX.Element => {
  const { t } = useTranslation();

  // Labels
  const labels = useMemo(() => {
    return {
      noRecentEvents: t(CDP_STRINGS.noRecentEvents),
      recentEvents: t(CDP_STRINGS.recentEvents),
    };
  }, [t]);

  const emptyStateProps: EmptyStateProps = {
    caption: labels.noRecentEvents,
    dataId: CUSTOMER_PROFILE_DATA_IDS.recentEventsEmptyState,
    isLite: true,
    svg: ICON_SWITCH_ACCESS_SHORTCUT_WITH_LIST,
  };

  return (
    <DataList
      classes="customer-recent-events__wrapper"
      empty={<EmptyState {...emptyStateProps} />}
      isInteractive={false}
      items={[]}
      title={labels.recentEvents}
    />
  );
};
